import React from 'react';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet } from '../../../hooks';
import { View } from '../../View';
import { IconButton } from '../../IconButton';
import { Divider } from '../../Divider';
import { useTextInputContext } from '../hooks';
const BasicTools = [
    { value: 'bold', icon: 'bold', format: 'bold' },
    { value: 'italic', icon: 'italic', format: 'italic' },
    { value: 'strike', icon: 'strikethrough', format: 'strike' },
    { value: 'underline', icon: 'underline', format: 'underline' }
];
const ListTools = [
    {
        value: 'bullet',
        icon: 'bullet-list',
        format: (active) => ['list', active ? 'bullet' : false]
    },
    {
        value: 'ordered',
        icon: 'number-list',
        format: (active) => ['list', active ? 'ordered' : false]
    }
];
export const Header = ({ entitiesEnabled, entities, onOpenEntities }) => {
    const styles = useStyleSheet(getStyles);
    const { toggleTool, editor, tools } = useTextInputContext();
    return (React.createElement(View, { style: styles.container },
        BasicTools.map((tool, index) => (React.createElement(IconButton, { key: tool.value, value: tool.icon, type: tools.includes(tool.value) ? 'secondary' : 'tertiary', accent: 'neutral', active: tools.includes(tool.value), size: 'sm', style: index !== 0 ? styles.tool : {}, onPress: () => {
                if (!editor)
                    return;
                toggleTool(tool.value, (tools) => {
                    editor.format(tool.format, tools.includes(tool.value));
                });
            } }))),
        React.createElement(Divider, { type: 'vertical', style: styles.divider }),
        ListTools.map((tool, index) => (React.createElement(IconButton, { key: tool.value, value: tool.icon, type: tools.includes(tool.value) ? 'secondary' : 'tertiary', accent: 'neutral', active: tools.includes(tool.value), size: 'sm', style: index !== 0 ? styles.tool : {}, onPress: () => {
                if (!editor)
                    return;
                toggleTool(tool.value, (tools) => {
                    editor.format(...tool.format(tools.includes(tool.value)));
                });
            } }))),
        React.createElement(Divider, { type: 'vertical', style: styles.divider }),
        React.createElement(IconButton, { value: 'link', onPress: () => {
                toggleTool('link-input');
            }, type: tools.includes('link') || tools.includes('link-input')
                ? 'secondary'
                : 'tertiary', active: tools.includes('link') || tools.includes('link-input'), accent: 'neutral', size: 'sm' }),
        entitiesEnabled && (React.createElement(View, null,
            React.createElement(IconButton, { value: 'braces-variable', onPress: onOpenEntities, type: 'tertiary', accent: 'neutral', size: 'sm', style: styles.tool }),
            entities))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'row',
        marginBottom: size.C
    },
    tool: {
        marginLeft: size.B
    },
    divider: {
        marginHorizontal: size.C,
        height: size.G,
        alignSelf: 'center',
        backgroundColor: color.invert2.p10
    }
}));
//# sourceMappingURL=Header.js.map